import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const INTERVAL_MS = 13000;
const VISIBLE_MS = 5000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % purchaseNotifications.length);
      }, VISIBLE_MS);
    };
    const firstTimer = window.setTimeout(show, 6000);
    const cycle = window.setInterval(show, INTERVAL_MS);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(cycle);
    };
  }, []);
  const current = purchaseNotifications[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-40 sm:bottom-5 sm:left-5" aria-live="polite" aria-atomic="true" data-id="element-145" data-mp="2oklvilxp48ws">
      <AnimatePresence data-id="element-146" data-mp="otbo1f2y4r4a">
        {visible ? <motion.div key={`${current.name}-${index}`} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[260px] items-center gap-2.5 rounded-full border border-navy/10 bg-ivory-light/95 py-2 pl-2 pr-3.5 shadow-card backdrop-blur sm:max-w-xs" data-id="element-147" data-mp="oriftvcopyu6">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal" data-id="element-148" data-mp="12j6p7qvju97g">
              <CheckIcon className="h-3.5 w-3.5 text-ivory-light" aria-hidden="true" data-id="element-149" data-mp="yj4tdychwa03" />
            </span>
            <p className="text-[11px] leading-tight text-navy sm:text-xs" data-id="element-150" data-mp="3n94gjuogqyat">
              <span className="font-semibold" data-id="element-151" data-mp="3j82dt3vc8443">
                {current.name} from {current.location}
              </span>{' '}
              purchased the Speech Therapy Clinical Toolkit™
            </p>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}